/* Collection + search pages: load the next page of products automatically as you scroll,
   instead of the 1 2 3 page numbers. Follows filters/sort (the theme swaps the grid in place;
   this notices and starts again from page 1 of the new results). If JS fails, the normal
   page numbers stay. */
(function () {
  if (window.__oayInfinite) return;
  window.__oayInfinite = true;

  var css = document.createElement('style');
  css.textContent =
    '.oay-inf-hide{display:none!important}' +
    '.oay-inf{display:flex;justify-content:center;align-items:center;min-height:72px;padding:18px 0 28px}' +
    '.oay-inf__spin{width:26px;height:26px;border:2.5px solid rgba(10,10,10,.12);border-top-color:#0A0A0A;border-radius:50%;animation:oayInfSpin .7s linear infinite;display:none}' +
    '.oay-inf.is-loading .oay-inf__spin{display:block}' +
    '.oay-inf.is-loading .oay-inf__btn{display:none}' +
    '.oay-inf__btn{font:inherit;font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:13px 26px;border:1.5px solid #0A0A0A;background:#fff;color:#0A0A0A;border-radius:4px;cursor:pointer}' +
    '@keyframes oayInfSpin{to{transform:rotate(360deg)}}';
  document.head.appendChild(css);

  var PAG = 'page-pagination, .pagination';
  var startPage = (function () {
    var m = location.search.match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  })();
  var S = null; /* { grid, sec, page, done, busy, failed, box, io } */

  function mainGrid() {
    var g = document.querySelector('#facet-main .product-list__inner');
    if (g) return g;
    var pag = document.querySelector('#main ' + PAG.split(', ').join(', #main '));
    if (!pag) return null;
    var p = pag.parentElement;
    for (var i = 0; i < 4 && p; i++) {
      var gs = p.querySelectorAll('.product-list__inner');
      if (gs.length) return gs[gs.length - 1];
      p = p.parentElement;
    }
    return null;
  }

  function pageUrl(n, sid) {
    var q = new URLSearchParams(location.search);
    q.set('page', n);
    if (sid) q.set('section_id', sid);
    return location.pathname + '?' + q.toString();
  }

  function nearView(el) {
    return el && el.isConnected && el.getBoundingClientRect().top < window.innerHeight + 900;
  }

  function hidePagination() {
    if (startPage > 1) return; /* came in on page 2+ from an old link: keep numbers so earlier pages stay reachable */
    var ps = document.querySelectorAll(PAG);
    for (var i = 0; i < ps.length; i++) {
      if (ps[i].closest('#mini-cart, .drawer, header, footer')) continue;
      ps[i].classList.add('oay-inf-hide');
    }
  }

  function removeBox(s) {
    if (s.io) s.io.disconnect();
    if (s.box && s.box.parentNode) s.box.parentNode.removeChild(s.box);
    s.box = null;
  }

  function placeBox(s) {
    if (s.done) { removeBox(s); return; }
    var anchor = s.grid.closest('product-list') || s.grid;
    if (s.box && s.box.isConnected && s.box.previousElementSibling === anchor) return;
    removeBox(s);
    var box = document.createElement('div');
    box.className = 'oay-inf';
    box.innerHTML = '<span class="oay-inf__spin" aria-hidden="true"></span><button type="button" class="oay-inf__btn">Load more</button>';
    anchor.insertAdjacentElement('afterend', box);
    box.querySelector('button').addEventListener('click', function () { s.failed = 0; load(s); });
    if ('IntersectionObserver' in window) {
      s.io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && !s.failed) load(s);
      }, { rootMargin: '0px 0px 900px 0px' });
      s.io.observe(box);
    }
    s.box = box;
  }

  function sync() {
    var grid = mainGrid();
    if (!grid) return;
    if (!S || S.grid !== grid) {
      if (S) removeBox(S);
      var first = !S;
      var sec = grid.closest('.shopify-section');
      S = {
        grid: grid,
        sid: sec && sec.id ? sec.id.replace(/^shopify-section-/, '') : '',
        page: first ? startPage : 1,
        /* first load: trust the page numbers. After a filter/sort swap the numbers may be stale,
           so just try the next page and stop when it comes back empty. */
        done: first ? !document.querySelector('#main a[rel="next"]') : grid.querySelectorAll(':scope > product-item').length < 12,
        busy: false, failed: 0, box: null, io: null
      };
    }
    hidePagination();
    placeBox(S);
  }

  function load(s) {
    if (s !== S || s.busy || s.done) return;
    s.busy = true;
    if (s.box) s.box.classList.add('is-loading');
    var want = s.page + 1;
    fetch(pageUrl(want, s.sid), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (s !== S) return; /* filters changed while loading: drop this page */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g2 = doc.querySelector('#facet-main .product-list__inner') || doc.querySelector('.product-list__inner');
        var have = {};
        var cur = s.grid.querySelectorAll(':scope > product-item a[href*="/products/"]');
        for (var k = 0; k < cur.length; k++) have[cur[k].getAttribute('href').split('?')[0]] = 1;
        var added = 0;
        if (g2) {
          var frag = document.createDocumentFragment();
          var kids = Array.prototype.slice.call(g2.children);
          for (var i = 0; i < kids.length; i++) {
            var c = kids[i];
            if (c.tagName === 'SCRIPT') continue;
            var a = c.querySelector('a[href*="/products/"]');
            if (a && have[a.getAttribute('href').split('?')[0]]) continue;
            c.removeAttribute('reveal');
            c.style.opacity = '1';
            var inner = c.querySelectorAll('[reveal]');
            for (var j = 0; j < inner.length; j++) inner[j].removeAttribute('reveal');
            frag.appendChild(document.importNode(c, true));
            added++;
          }
          s.grid.appendChild(frag);
        }
        s.page = want;
        if (!added || !doc.querySelector('a[rel="next"]')) s.done = true;
        s.failed = 0;
      })
      .catch(function () { s.failed = (s.failed || 0) + 1; })
      .then(function () {
        s.busy = false;
        if (s.box) s.box.classList.remove('is-loading');
        if (s !== S) return;
        if (s.done) { removeBox(s); return; }
        if (!s.failed && nearView(s.box)) setTimeout(function () { load(s); }, 50);
      });
  }

  /* fast flicks can jump past the loader into the footer: also check on scroll */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (S && !S.done && !S.busy && !S.failed && nearView(S.box)) load(S);
    });
  }

  var t = null;
  function schedule() { if (t) return; t = setTimeout(function () { t = null; sync(); }, 150); }

  function start() {
    sync();
    window.addEventListener('scroll', onScroll, { passive: true });
    var main = document.getElementById('main') || document.body;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length || list[i].removedNodes.length) {
          var n = list[i].target;
          if (S && S.box && S.box.contains(n)) continue;
          schedule();
          return;
        }
      }
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
